import TicketsAttentionQueue from "../Tickets/components/TicketsAttentionQueue";
import TicketsSlaBreaches from "../Tickets/components/TicketsSlaBreaches";

/**
 * Inbox — оперативный экран менеджера поддержки.
 *
 * Показывает только то, что требует действия прямо сейчас:
 *   - очередь требующая внимания (NEW без исполнителя / WAITING > 24h / HIGH);
 *   - SLA-нарушители.
 *
 * Историческая аналитика (тренды жалоб, антирейтинги, тематики) живёт на /admin/stats.
 */
const InboxPage = () => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: 24,
        }}
      >
        <div>
          <h3 style={{ margin: 0 }}>Входящие</h3>
          <div style={{ fontSize: 13, color: "#64748B", marginTop: 4 }}>
            Что требует внимания прямо сейчас
          </div>
        </div>
      </div>

      <section style={{ marginBottom: 32 }}>
        <TicketsAttentionQueue waitingHours={24} limit={5} />
      </section>

      <section>
        <TicketsSlaBreaches limit={10} />
      </section>
    </div>
  );
};

export default InboxPage;
